import React, {Component} from 'react';
import {Container} from 'react-bootstrap';
import {FormattedHTMLMessage, FormattedMessage} from 'react-intl';

class HowTo extends Component {

	render() {
		return (
				<section className="page howTo-page mt-4">
					<Container>
						<h2 className="page-title"><FormattedMessage id="howto.title" default="How To"/></h2>
						<div className="page-content mt-2">
						<FormattedHTMLMessage  id="howto.content"/>
						</div>
					</Container>
				</section>
		);
	}
}

export default HowTo;
